import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DeviceIdService } from '@ridango/core/lib/services';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'rwidget-anonymous-user-modal',
    templateUrl: '../anonymous-user-modal.component.html'
})
export class AnonymousUserModalComponent implements OnInit {
    private routeParams: string[] = ['purchase-v2'];

    constructor(
        public dialogRef: MatDialogRef<AnonymousUserModalComponent>,
        private translate: TranslateService,
        private router: Router,
        private deviceIdService: DeviceIdService,
        @Inject(MAT_DIALOG_DATA) public data: { routeParams: string[] }
    ) {}

    ngOnInit() {
        if (!this.data?.routeParams) return;
        this.routeParams = this.data.routeParams;
    }

    cancel(): void {
        this.dialogRef.close();
    }

    register() {
        this.router.navigate([this.translate.currentLang, 'register']);
        this.cancel();
    }

    login() {
        this.deviceIdService.setLocalUserExist(true);
        if (this.deviceIdService.getAccessDeviceToken()) {
            this.router.navigate([this.translate.currentLang, ...this.routeParams]);
        }
        this.cancel();
    }
}
